import { render, staticRenderFns } from "./yuanxiaoxiangqing.vue?vue&type=template&id=88101d28&scoped=true"
import script from "./yuanxiaoxiangqing.vue?vue&type=script&lang=js"
export * from "./yuanxiaoxiangqing.vue?vue&type=script&lang=js"
import style0 from "./yuanxiaoxiangqing.vue?vue&type=style&index=0&id=88101d28&prod&lang=less&scoped=true"
import style1 from "./yuanxiaoxiangqing.vue?vue&type=style&index=1&id=88101d28&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88101d28",
  null
  
)

export default component.exports